import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formatPrice, formatPercent } from '../../../../helpers/formatNumbers';
import ItemPrice from './ItemPrice';

class QuantityContainer extends Component {
  updateItemQuantity = (event) => {
    const { itemId } = this.props;
    const designId = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
    const quantity = Number(event.target.value);
    this.props.updateQuantity(itemId, quantity, designId);
  }
  render() {
    const {
      isMandi,
      isAutoReleaseDesign,
      itemId,
      retail,
      subtotal,
      quantity,
      lineItemRetail,
    } = this.props;

    const quantityDropDownChoices = [];
    for (let i = 1; i <= 50; i += 1) {
      quantityDropDownChoices.push(<option key={`${itemId} - ${i}`} value={i}>{i}</option>);
    }

    const isOnSale = retail > subtotal;
    const savingPercentage = (retail - subtotal) / retail;

    const itemPriceProps = {
      isOnSale,
      savingPercentage,
      lineItemRetail,
    };

    return (
      <div className="updateContainer">
        {!isMandi &&
          (
            <React.Fragment>
              <ItemPrice {...itemPriceProps} />
              <div className="updateColumn">
                <span className="columnTitle">Quantity</span>
                <select defaultValue={quantity} id="updateSelect" onChange={this.updateItemQuantity}>
                  {quantityDropDownChoices}
                </select>
              </div>
            </React.Fragment>
          )}
        {!isAutoReleaseDesign &&
          <div className="updateColumn">
            <span className="columnTitle">Total</span>
            {isOnSale && (
              <span className="itemRetail">{formatPrice(retail)}</span>
            )}
            <span className="itemSubtotal">{formatPrice(subtotal)}</span>
            {isOnSale && (
              <div className="onSaleText">
                Save {formatPercent(savingPercentage * 100)}
              </div>
            )}
          </div>
        }
        {isAutoReleaseDesign &&
          <div className="updateColumn">
            <span className="columnTitle">Total</span>
            <span className="autoReleaseItemRetail">{formatPrice(retail)}</span>
          </div>
        }
      </div>
    );
  }
}

QuantityContainer.propTypes = {
  isMandi: PropTypes.bool,
  isAutoReleaseDesign: PropTypes.bool,
  itemId: PropTypes.string.isRequired,
  retail: PropTypes.number.isRequired,
  subtotal: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  lineItemRetail: PropTypes.number.isRequired,
  updateQuantity: PropTypes.func.isRequired,
};


QuantityContainer.defaultProps = {
  isMandi: false,
  isAutoReleaseDesign: false,
};

export default QuantityContainer;
